module.exports = __webpack_public_path__ + "img/logo_white.97dc1e2f.png";